/** Auth hook — hydrates auth state on mount and sets up periodic token refresh. */

import { useEffect } from "react";
import { useAuthStore } from "../stores/auth-store";

export function useAuth() {
  const store = useAuthStore();
  const { fetchMe, refreshSession, isAuthenticated } = store;

  // Hydrate auth state from cookie on mount
  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  // Refresh token 5 minutes before expiry (access token is 1h)
  useEffect(() => {
    if (!isAuthenticated) return;
    const interval = setInterval(refreshSession, 55 * 60 * 1000); // 55 min
    return () => clearInterval(interval);
  }, [isAuthenticated, refreshSession]);

  return store;
}
